export class DateHelpers {

    constructor() {
        return {
            atBeginningOfDay: this.atBeginningOfDay,
            atEndOfDay: this.atEndOfDay,
            addDays: this.addDays,
            addHours: this.addHours,
            toShortDateTime: this.toShortDateTime
        }
    }

    atBeginningOfDay(date) {
        const result = new Date(date);
        result.setHours(0, 0, 0, 0);
        return result;
    }

    atEndOfDay(date) {
        const result = new Date(date);
        result.setHours(23, 59, 59, 999);
        return result;
    }

    addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    addHours(date, hours) {
        const result = new Date(date);
        result.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        return result;
    }

    toShortDateTime(date) {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        let ampm = 'AM';
        let hours = date.getHours();
        let minutes = date.getMinutes();
        if (hours > 12) {
            hours = hours - 12;
            ampm = 'PM';
        }
        if (minutes < 10) {
            minutes = `0${minutes}`;
        }
        return `${month}/${day} ${hours}:${minutes} ${ampm}`;
    }


}